import { useEffect, useState } from "react";
import { collection, getDocs, query, where, or, and } from "firebase/firestore";
import { db } from "../firebase";
import { useParams } from "react-router-dom";
import "../styles/categories.css";
import "../styles/highlightsection.css";
import LoadingPage from "../components/Loading";
import EventCell from "../components/EventCell";

function CategoryDetails() {
  const [eventData, setEventData] = useState([]);
  const [catData, setCatData] = useState([]);
  const { categoryName } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      // console.log(categoryName + " " + categoryName.toLocaleLowerCase());
      const q = query(
        collection(db, "events"),
        and(
          where("status", "==", true),
          or(
            where("event_type", "==", categoryName),
            where("event_type", "==", categoryName.toLowerCase())
          )
        )
      );

      const querySnapshot = await getDocs(q);
      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEventData(items);
    };

    const fetchCatData = async () => {
      const q = query(
        collection(db, "event_categories"),
        where("name", "==", categoryName)
      );

      const querySnapshot = await getDocs(q);
      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // console.log("fetchCatData :", items);
      setCatData(items[0]);
    };

    fetchData();
    fetchCatData();
  }, [categoryName]);

  if (eventData.length === 0) {
    return <LoadingPage />;
  }
  return (
    <>
      <div
        className="trek-banner"
        style={{ "--cols": eventData.slice(0, 6).length }}
      >
        <div className="banner-images">
          {eventData.slice(0, 6).map((src, i) => (
            <img key={i} src={src.main_image} alt={`bg-${i}`} />
          ))}
        </div>

        <div className="dark-overlay" />

        <div className="center-text">
          <span className="fade-line left" />
          <h1>{catData.name}</h1>
          <span className="fade-line right" />
        </div>
      </div>
      <div className="category-event-grid-container">
        {eventData.map((item, index) => (
          <div key={index} className="category-event-container">
            <EventCell item={item} />
          </div>
        ))}
      </div>
    </>
  );
}

export default CategoryDetails;
